import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace QuestionFields {
  export enum QAField {
    EnableQADelete = 'QA.EnableQADelete',
    EnableSubjectMatter = 'QA.EnableSubjectMatter',
    EnableIssueLevel = 'QA.EnableIssueLevel',
  }
}

class QAConfig extends SettingsSubModule {
  @SettingsSubModule.value(QuestionFields.QAField.EnableQADelete, false) enableQADelete: SettingValue<boolean>;
  @SettingsSubModule.value(QuestionFields.QAField.EnableSubjectMatter, false)
  enableSubjectMatter: SettingValue<boolean>;
  @SettingsSubModule.value(QuestionFields.QAField.EnableIssueLevel, false) enableIssueLevel: SettingValue<boolean>;
}

export class QuestionModule extends SettingsModule {
  @SettingsModule.value(QAConfig) qA: QAConfig;
}
